import type { FormikValues, FormikErrors, FormikTouched } from "formik";

export function hasFormikError<Values extends FormikValues = FormikValues>(
  formik: { errors: FormikErrors<Values>; touched: FormikTouched<Values> },
  value: keyof Values,
): boolean {
  const hasError = Boolean(formik.errors[value] && formik.touched[value]);
  return hasError;
}
